(function () {
  'use strict';

  if (customElements.get('sh-usp-slider')) return;

  var AUTOPLAY_FALLBACK_MS = 4000;

  class ShUspSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-sh-usp-track]');
      this.slides = this.track ? Array.from(this.track.children) : [];
      this.dots = Array.from(this.querySelectorAll('[data-sh-usp-dots] > *'));

      if (!this.track || this.slides.length < 2) return;

      this.index = 0;
      this.timer = null;
      this.paused = false;
      this.interval = parseInt(this.dataset.autoplay, 10) || AUTOPLAY_FALLBACK_MS;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onPause = this.onPause.bind(this);
      this.onResume = this.onResume.bind(this);
      this.onVisibilityChange = this.onVisibilityChange.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onBlockDeselect = this.onBlockDeselect.bind(this);

      var prev = this.querySelector('[data-sh-usp-prev]');
      var next = this.querySelector('[data-sh-usp-next]');
      if (prev) prev.addEventListener('click', this.onPrev);
      if (next) next.addEventListener('click', this.onNext);

      this.addEventListener('mouseenter', this.onPause);
      this.addEventListener('mouseleave', this.onResume);
      this.addEventListener('focusin', this.onPause);
      this.addEventListener('focusout', this.onResume);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.goTo(0);
      this.play();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    goTo(target) {
      var count = this.slides.length;
      this.index = ((target % count) + count) % count;
      this.track.style.transform = 'translateX(-' + this.index * 100 + '%)';
      this.dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === this.index);
      }, this);
    }

    play() {
      this.stop();
      if (this.reducedMotion || this.paused) return;
      this.timer = setInterval(
        function () {
          this.goTo(this.index + 1);
        }.bind(this),
        this.interval
      );
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    onPrev() {
      this.goTo(this.index - 1);
      this.play();
    }

    onNext() {
      this.goTo(this.index + 1);
      this.play();
    }

    onPause() {
      this.paused = true;
      this.stop();
    }

    onResume() {
      this.paused = false;
      this.play();
    }

    onVisibilityChange() {
      if (document.hidden) {
        this.stop();
      } else {
        this.play();
      }
    }

    onBlockSelect(event) {
      var index = this.slides.indexOf(event.target);
      if (index === -1) return;
      this.paused = true;
      this.stop();
      this.goTo(index);
    }

    onBlockDeselect(event) {
      if (this.slides.indexOf(event.target) === -1) return;
      this.onResume();
    }
  }

  customElements.define('sh-usp-slider', ShUspSlider);
})();
